import React from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import moment from "moment";
const { groupBy, sortBy, uniqBy, sumBy } = require("lodash");

function EventsChart(props) {
  let users = props.data.map((i) => {
    return i.user_docs;
  });
  users = uniqBy(users, "id").map((i) => {
    return {
      id: i.id,
      name: i.firstname,
    };
  });

  const usersName = users.map((i) => {
    return i.name;
  });

  let data = sortBy(props.data, "createdAt").map((i) => {
    return {
      ...i,
      ...{ date: moment(i.createdAt).format("DD/MM") },
    };
  });

  const groupedData = groupBy(data, "date");

  let lastDays = [...new Array(props.days)].map((i, idx) =>
    moment().startOf("day").subtract(idx, "days")
  );

  lastDays = lastDays.map((i) => {
    return moment(i).format("DD/MM");
  });

  lastDays = lastDays.reverse().map((i) => {
    const groupUsers = groupBy(groupedData[i], "user_docs.id");
    let data = users.map((i) => {
      return {
        name: i.name,
        count: groupUsers[i.id] ? groupUsers[i.id].length : 0,
      };
    });

    const total = sumBy(data, "count");

    data = data.reduce((acc, { name, count }) => {
      acc[name] = count;
      return acc;
    }, {});

    return {
      date: i,
      ...data,
      Total: total,
    };
  });

  console.log("lastDays", lastDays);

  return (
    <ResponsiveContainer width={"100%"} height={350}>
      <ComposedChart
        data={lastDays}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip cursor={{ fill: "#eee" }} />
        <Legend
          verticalAlign="top"
          align="right"
          wrapperStyle={{
            left: 0,
            top: 0,
            paddingTop: 10,
          }}
        />
        {usersName.includes("Lin") ? (
          <Bar dataKey="Lin" fill="#7CB9E8" />
        ) : null}
        {usersName.includes("Anny") ? (
          <Bar dataKey="Anny" fill="#FB607F" />
        ) : null}
        {usersName.includes("Grace") ? (
          <Bar dataKey="Grace" fill="#F19CBB" />
        ) : null}
        <Line type="monotone" dataKey="Total" stroke="#C2B280" />
      </ComposedChart>
    </ResponsiveContainer>
  );
}

export default EventsChart;
